// extracted by mini-css-extract-plugin
module.exports = {"image-placeholder":"_2E95L","card__body":"aaBgj","card__title":"_1EtI-","card__text":"a5X0f","button-wrapper":"vcr4o","pretitle":"_7LbH0","card":"j97Y6"};